import {useMobileView} from "./useMobileView";

export type View = "webMobile" | "webDesktop" | "native";

export function useView(): View {
    const isMobileOnWeb = useMobileView();

    return process.env.IS_WEB ? (isMobileOnWeb ? "webMobile" : "webDesktop") : "native";
}
